export default {
  home: {
    hero: {
      title: 'Cámaras de seguridad y sistemas de alarma para particulares y empresas',
      subtitle: 'SSG Signaltechnik planifica, instala y mantiene modernos sistemas de videovigilancia y alarma en toda la región Rin-Meno: desde Hainburg pasando por Offenbach, Fráncfort y Hanau hasta Darmstadt y Groß-Gerau. Adaptado individualmente a su propiedad, sus necesidades y las zonas que realmente deben protegerse.',
      ctaPrimary: 'Solicitar una primera consulta gratuita',
      ctaSecondary: 'Iniciar el planificador de cámaras',
    },
    trust: {
      '0': 'Planificación individual',
      '1': 'Instalación profesional',
      '2': 'Configuración de la app',
      '3': 'Atención personal',
      '4': 'Particulares y empresas',
    },
    service: {
      eyebrow: 'Nuestro enfoque',
      title: 'Mucho más que instalar cámaras',
      lead: 'Cada propiedad es diferente. Por eso analizamos su situación a fondo antes de proponer una sola cámara. El servicio completo incluye:',
      steps: {
        '0': 'Analizar las necesidades y el inmueble',
        '1': 'Elegir el tipo de cámara y el ángulo de visión',
        '2': 'Comprobar posibles puntos ciegos',
        '3': 'Planificar el cableado, la red y la grabación',
        '4': 'Montar y orientar de forma profesional',
        '5': 'Configurar la app y el acceso remoto',
        '6': 'Instruir al cliente de forma clara',
        '7': 'Mantener el sistema si lo desea',
      },
      more: 'Descubrir todos los servicios',
    },
    solutions: {
      eyebrow: 'Tipos de inmueble',
      title: 'Soluciones para cada propiedad',
      lead: 'Ya sea una vivienda, un comercio o una nave de producción: encontramos la solución adecuada para sus necesidades.',
      filter: { alle: 'Todos', privat: 'Privado', gewerbe: 'Empresa', innen: 'Interior', aussen: 'Exterior', neu: 'Nuevo sistema' },
      more: 'Saber más',
      viewAll: 'Ver todas las soluciones',
    },
    area: {
      eyebrow: 'Zona de servicio',
      title: 'Cámaras de seguridad y alarmas en toda la región Rin-Meno',
      lead: 'Desde nuestra sede en Hainburg cubrimos toda el área metropolitana: Fráncfort, Offenbach, Hanau, Darmstadt, Groß-Gerau y todos los municipios de alrededor. Planificación, instalación y mantenimiento de su cámara o alarma, siempre de forma personal y presencial.',
      viewAll: 'Ver todas las zonas de servicio',
    },
    tech: {
      eyebrow: 'Planificación técnica',
      title: 'La tecnología adecuada para el objetivo correcto',
      lead: 'No solo cuentan los megapíxeles. Un buen sistema de cámaras surge de la combinación de muchos factores.',
      points: {
        '0': { title: 'Interior o exterior', desc: 'La humedad, la intemperie y la temperatura determinan la elección de la cámara.' },
        '1': { title: 'Luz y condiciones nocturnas', desc: 'Soluciones día/noche y de baja luminosidad para cada situación de iluminación.' },
        '2': { title: 'Visión general o detalle', desc: 'Gran angular para la vista global o teleobjetivo para rostros y matrículas.' },
        '3': { title: 'Distancia y altura de montaje', desc: 'Cuanto más alto y lejos, mayor resolución y mejor objetivo se necesitan.' },
        '4': { title: 'Ángulo de visión y objetivo', desc: 'Focal fija, varifocal o motorizada, según el propósito.' },
        '5': { title: 'Grabación y almacenamiento', desc: 'Grabador local con almacenamiento en disco duro según necesidad.' },
        '6': { title: 'Acceso desde la app', desc: 'Vista en vivo y reproducción desde el móvil, según sistema y configuración.' },
        '7': { title: 'Notificaciones de eventos', desc: 'Avisos push ante movimiento o eventos definibles, según el sistema.' },
        '8': { title: 'Ampliabilidad', desc: 'Los sistemas existentes suelen poder ampliarse con más cámaras.' },
      },
    },
    process: {
      eyebrow: 'Proceso',
      title: 'Así funciona su proyecto',
      lead: 'De la primera consulta al sistema terminado: transparente y personal.',
      steps: {
        '0': { title: 'Primera consulta', desc: 'Hablamos de sus necesidades, su inmueble y las zonas que desea vigilar.' },
        '1': { title: 'Visita y planificación', desc: 'Cita in situ para analizar luz, ángulos, puntos de montaje y cableado.' },
        '2': { title: 'Presupuesto individual', desc: 'Recibe un presupuesto transparente con la tecnología adecuada y un alcance claro.' },
        '3': { title: 'Instalación y configuración', desc: 'Montaje profesional, conexión de red, configuración del grabador y de la app.' },
        '4': { title: 'Formación y soporte', desc: 'Aprende a manejar el sistema. Estamos a su lado, incluso después.' },
      },
    },
    refs: {
      eyebrow: 'Proyectos de referencia',
      title: 'Proyectos realizados',
      lead: 'Una selección de nuestro portfolio: de la vivienda privada a instalaciones comerciales.',
      viewAll: 'Descubrir todas las soluciones',
      items: {
        '0': { label: 'Vivienda unifamiliar', desc: 'Sistema completo con 6 cámaras, NVR y conexión a la app' },
        '1': { label: 'Comercio – boutique', desc: 'Sala de ventas y almacén con 4 cámaras y visión nocturna' },
        '2': { label: 'Logística – almacén', desc: 'Vigilancia de grandes superficies con gran angular y PTZ' },
        '3': { label: 'Consulta – recepción médica', desc: 'Vigilancia interior discreta con enmascaramiento de privacidad' },
        '4': { label: 'Inmobiliaria – edificio de viviendas', desc: 'Entrada y zonas exteriores con señalización' },
      },
    },
    care: {
      eyebrow: 'Mantenimiento y soporte',
      title: 'SSG Care',
      lead: 'Su tecnología de cámaras debe funcionar de forma fiable a largo plazo. Con SSG Care obtiene una suscripción de soporte flexible: cancelable mensualmente o con plazo acordado.',
      list: {
        '0': 'Revisiones periódicas del sistema y actualizaciones de firmware',
        '1': 'Ayuda con problemas de app y acceso',
        '2': 'Asistencia al cambiar de móvil',
        '3': 'Comprobación de grabación y almacenamiento',
        '4': 'Atención prioritaria según acuerdo',
      },
      cta: 'Descubrir SSG Care',
    },
    planner: {
      eyebrow: 'Herramienta interactiva',
      title: 'El planificador de cámaras SSG',
      lead: 'Dibuje habitaciones o superficies, marque zonas de vigilancia importantes y pruebe posibles posiciones de cámara con conos de visión. El resultado es un plano preliminar no vinculante para su conversación con nosotros.',
      list: {
        '0': 'Dibujar habitaciones y paredes',
        '1': 'Colocar iconos de cámara con arrastrar y soltar',
        '2': 'Conos de visión giratorios con valoración de cobertura',
        '3': 'Marcar zonas de vigilancia y privacidad',
        '4': 'Enviar el resultado como consulta o imprimirlo',
      },
      cta: 'Iniciar el planificador de cámaras',
    },
    faq: {
      eyebrow: 'Preguntas frecuentes',
      title: 'Lo que los clientes nos preguntan a menudo',
      viewAll: 'Ver todas las preguntas',
      items: {
        '0': { question: '¿Cuántas cámaras necesito?', answer: 'Depende del tamaño de su inmueble, las zonas a vigilar y el nivel de detalle deseado. Tras una primera consulta y una visita, elaboramos una propuesta individual para usted.' },
        '1': { question: '¿Puedo ver las cámaras en el móvil?', answer: 'Sí, en la mayoría de los sistemas modernos es posible el acceso mediante app. Configuramos la conexión de la app directamente durante la instalación.' },
        '2': { question: '¿Funcionan las cámaras en la oscuridad?', answer: 'Sí, para exteriores e interiores poco iluminados hay cámaras especiales día/noche y de baja luminosidad con visión nocturna por infrarrojos o en color.' },
        '3': { question: '¿Cuánto cuesta un sistema de cámaras?', answer: 'El coste depende del número de cámaras, el inmueble, el cableado y el alcance de funciones deseado. Con gusto elaboramos un presupuesto individual y sin compromiso.' },
      },
    },
    cta: {
      title: 'Averigüemos juntos qué solución se adapta a su propiedad.',
      lead: 'Llámenos, escríbanos o comience directamente con el planificador de cámaras. Le responderemos enseguida.',
      primary: 'Solicitar una primera consulta gratuita',
      secondary: 'Iniciar el planificador de cámaras',
    },
  },
  company: {
    solutions: {
      home: { title: 'Hogar y parcela', description: 'De la puerta de entrada al garaje: vigilancia discreta para su vivienda.' },
      retail: { title: 'Comercio y hostelería', description: 'Zona de caja, entrada y almacén: protegidos de forma profesional.' },
      office: { title: 'Oficina y consulta', description: 'Recepción, pasillos y zonas sensibles: planificados con privacidad.' },
      warehouse: { title: 'Almacén y logística', description: 'Vigilancia de grandes superficies con gran angular y visión nocturna.' },
      workshop: { title: 'Taller e industria', description: 'Cámaras robustas para entornos exigentes: naves y zonas exteriores.' },
      apartment: { title: 'Edificios de viviendas e inmuebles', description: 'Entradas, escaleras y zonas exteriores, para inquilinos y propietarios.' },
    },
  },
};